import React, { useMemo } from "react";
import { Textarea, TextareaProps } from "./ui/textarea";

export const TextareaWithLimitInfo = React.forwardRef<
  HTMLTextAreaElement,
  TextareaProps
>((props, ref) => {
  const length = useMemo(() => {
    const value = props.value?.toString();
    return value?.length || 0;
  }, [props.value]);
  return (
    <>
      <Textarea ref={ref} {...props} />
      {props.maxLength && (
        <div className="text-xs text-muted-foreground">
          {length}/{props.maxLength}
        </div>
      )}
    </>
  );
});
TextareaWithLimitInfo.displayName = "TextareaWithLimitInfo";
